module.exports = __webpack_public_path__ + "static/media/course_image.db955d26.jpg";